import { useEffect, useState } from "react";
import { unicodeToString } from "../../Js/Common";

const BookText = (props) => {
  let [classes, setClasses] = useState("");

  useEffect(() => {
    let attributeArr = props.data.attribute.split(" ");
    let classname = "";
    for (let i = 0; i < attributeArr.length; i++) {
      switch (attributeArr[i]) {
        case "left":
          classname = classes + "text-left ";
          setClasses(classname);
          break;
        case "right":
          classname = classes + "text-right ";
          setClasses(classname);
          break;
        case "center":
          classname = classes + "text-center ";
          setClasses(classname);
          break;
        case "indent-small":
          classname = classes + "indentSm ";
          setClasses(classname);
          break;
        case "indent-medium":
          classname = classes + "indentMd ";
          setClasses(classname);
          break;
        case "text-color-white":
          classname = classes + "text-white ";
          setClasses(classname);
          break;
        case "text-color-black":
          classname = classes + "text-black ";
          setClasses(classname);
          break;
        case "width-small":
          classname = classes + "containerSm ";
          setClasses(classname);
          break;
        case "width-medium":
          classname = classes + "containerMd ";
          setClasses(classname);
          break;
        case "width-large":
          classname = classes + "containerLg ";
          setClasses(classname);
          break;
        case "align-left":
          classname = classes + "containerLeft ";
          setClasses(classname);
          break;
        case "align-right":
          classname = classes + "containerRight ";
          setClasses(classname);
          break;
        case "align-center":
          classname = classes + "containerCenter ";
          setClasses(classname);
          break;
      }
    }
  }, []);

  return (
    <>
      {props.data && props.data.text && (
        <div
          className={
            props.fontSize && props.fontSize == "18px"
              ? `${classes} q-pa-sm fontbtm_20_t fontbtm_14 fontFam`
              : `${classes} q-pa-sm fontbtm_20_t fontFam`
          }
          style={{
            fontSize: props.fontSize,
            fontWeight: "normal",
            lineHeight: "1.6",
            padding: 6,
            marginRight: 12,
            marginLeft: 12
          }}
        >
          {unicodeToString(props.data.text)}
        </div>
      )}
    </>
  );
};

export default BookText;
